const date = {
  // 设置时间格式 unit中间分隔符 replace被替换的分隔符
  format: (dt, unit = '-', replace = '/') => {
    if (dt === '汇总') return '汇总';
    if (!dt) return '';
    // 20200820 -> 2020-08-20
    if (dt.length === 8) {
      return dt.slice(0, 4) + unit + dt.slice(4, 6) + unit + dt.slice(6, 8);
    }
    // 2020/08/20 -> 2020-08-20
    if (dt.length === 10) {
      return dt.replaceAll(replace, unit);
    }
    // 带有小时分钟秒的时间 20200820 11:00:00 或 2020/08/20 11:00:00 -> 2020-08-20 11:00:00
    if (dt.length > 10) {
      if (Number(dt.slice(0, 8))) { // 截取前8位为 20200820 的格式 Number()后不会为NaN
        return dt.slice(0, 4) + unit + dt.slice(4, 6) + unit + dt.slice(6, 8) + dt.slice(8);
      } else { // 截取前8位为 2020-08- 的格式 Number()后为NaN
        return dt.slice(0, 10).replaceAll(replace, unit) + dt.slice(10);
      }
    }
    // new Date()数据 -> 2020-08-20
    if (dt.getTime) {
      // new Date().toLocaleDateString()  --->  兼容性问题
      // 在Trident内核浏览器中显示 2020年10月18日
      // 在正常浏览器里显示  2020/10/18
      // let newDate = date.toLocaleDateString().split('/');
      let newDate = dt.toLocaleDateString().replace(/[年,月,日]/g, '/').split('/');
      if (newDate[1]?.length === 1) newDate[1] = `0${newDate[1]}`; //月
      if (newDate[2]?.length === 1) newDate[2] = `0${newDate[2]}`; //日
      return newDate.join(unit);
    }
    return '';
  },
  // 获取一组开始时间-结束时间 Number
  get(start, end) {
    // start 0为今天，正数向前推，负数向后推
    // 0 今天  1 昨天  2 前天  -1 明天  -2  后天
    let startDate = new Date(new Date().getTime() - 86400000 * start);
    startDate = date.format(startDate, '');
    if (end === undefined) return startDate;
    // end 0为今天，正数向后推，负数向前推
    //  0 今天  1 明天  2 后天  -1 昨天  -2  前天
    // [ 0, 0 ] 今天  [ 1, 1 ] 昨天到明天  [ 2, -1 ] 前天到昨天
    let endDate = new Date(new Date().getTime() + 86400000 * end);
    endDate = date.format(endDate, '');
    return [ startDate, endDate ];
  },
  // 获取当前时分秒
  currentTime(delay) { // delay: { hour: 0, minutes: 10, seconds: 0 } 向后延迟多长时间
    let date = new Date();
    let hour = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    if (delay) {
      // 小时延迟
      if (delay.hour) hour += delay.hour;
      // 分钟延迟
      if (delay.minutes) minutes += delay.minutes;
      // 秒延迟
      if (delay.seconds) seconds += delay.seconds;
      // 处理时间
      if (seconds > 60) {
        minutes += 1;
        seconds -= 60;
      }
      if (minutes > 60) {
        hour += 1;
        minutes -= 60;
      }
      if (hour > 23) {
        hour = 23;
        minutes = 59;
        seconds = 59;
      }
    }
    // 小于10前面加0
    if (hour < 10) hour = '0' + hour;
    if (minutes < 10) minutes = '0' + minutes;
    if (seconds < 10) seconds = '0' + seconds;
    return `${ hour }:${ minutes }:${ seconds }`;
  },
  // 获取本月或上个月的一组时间  Number 0 本月 正数向前推月份
  // 0 本月[ 本月第一天, 昨天 ]  1 上个月[ 上个月第一天, 上个月最后一天 ]
  month(month) {
    let startDate, endDate;
    startDate = new Date().toLocaleDateString().replace(/[年,月,日]/g, '/').split('/');
    startDate[2] = '01'; // 本月第一天
    if (month === 0) { // 本月
      startDate = new Date(startDate.join('/'));
      endDate = new Date(new Date().getTime() - 86400000);
    } else { // 其他月
      if (startDate[1] - month <= 0) { // 去年及以前
        if ((startDate[1] - month) / 12 <= -1) { // 前年及以前
          startDate[0] = String(Number(startDate[0]) + (Math.ceil((startDate[1] - month) / 12) - 1));
          startDate[1] = String(12 * -(Math.ceil((startDate[1] - month) / 12) - 1) + (startDate[1] - month));
        } else { // 去年
          startDate[0] = String(startDate[0] - 1);
          startDate[1] = String(12 + (startDate[1] - month));
        }
        endDate = new Date(new Date(`${ Number(startDate[0]) + 1 }/${ (Number(startDate[1]) + 1) > 12 ? (12 - (Number(startDate[1]) - 1)) : (Number(startDate[1]) + 1) }/${ startDate[2] }`).getTime() - 86400000);
        startDate = new Date(startDate.join('/'));
      } else { // 今年
        startDate[1] = String(startDate[1] - month);
        endDate = new Date(new Date(`${ Number(startDate[0]) + 1 }/${ Number(startDate[1]) + 1 }/${ startDate[2] }`).getTime() - 86400000);
        startDate = new Date(startDate.join('/'));
      }
    }
    startDate = date.format(startDate, '');
    endDate = date.format(endDate, '');
    return [ startDate, endDate ];
  },
  // 获取weekHour数据 param '1_7,1_8,2_5,2_10'，return [ '星期一：7:00-9:00', '星期二：5:00-11:00' ]
  getWeekHour(weekHourData) {
    if (!weekHourData) return '';
    let weekHourArr = weekHourData.split(',');
    let data = [
      { day: '星期一', value: '', arr: [] },
      { day: '星期二', value: '', arr: [] },
      { day: '星期三', value: '', arr: [] },
      { day: '星期四', value: '', arr: [] },
      { day: '星期五', value: '', arr: [] },
      { day: '星期六', value: '', arr: [] },
      { day: '星期日', value: '', arr: [] },
    ];
    let returnData = []; // 返回的数据
    for (let i in weekHourArr) {
      if (weekHourArr[i].includes('1_')) data[0].arr.push(Number(weekHourArr[i].slice(2)));
      if (weekHourArr[i].includes('2_')) data[1].arr.push(Number(weekHourArr[i].slice(2)));
      if (weekHourArr[i].includes('3_')) data[2].arr.push(Number(weekHourArr[i].slice(2)));
      if (weekHourArr[i].includes('4_')) data[3].arr.push(Number(weekHourArr[i].slice(2)));
      if (weekHourArr[i].includes('5_')) data[4].arr.push(Number(weekHourArr[i].slice(2)));
      if (weekHourArr[i].includes('6_')) data[5].arr.push(Number(weekHourArr[i].slice(2)));
      if (weekHourArr[i].includes('7_')) data[6].arr.push(Number(weekHourArr[i].slice(2)));
    }
    for (let i in data) {
      let hour = null;
      let value = '';
      for (let j in data[i].arr) {
        // 第一次循环给hour赋值为当前循环的小时和第一个时间开始时间，并跳过第一次循环
        if (hour === null) {
          hour = data[i].arr[j];
          value += hour + ':00';
          continue;
        }
        // 上一次循环的hour + 1等于这次循环的小时 && 当前不是最后一次循环
        // 重新给hour赋值为当前循环的小时，并跳过当前循环
        if (hour + 1 === data[i].arr[j]) {
          hour = data[i].arr[j];
          continue;
        }
        // 上一次循环的hour + 1不等于这次循环的小时
        value += '-' + (hour + 1) + ':00' + '、'; // 设置上次循环的结束时间
        hour = data[i].arr[j]; // 重新给hour赋值为当前循环的小时
        value += hour + ':00'; // 设置当前小时数为新的开始时间
      }
      // 设置最后一个时间段的结束时间
      value += '-' + (hour + 1) + ':00';
      data[i].value += value;
      if (data[i].value) returnData.push(data[i].day + '：' + data[i].value);
    }
    return returnData;
  }
}

export default date;